import { isVideoFile } from "@utils/misc";
import { cn } from "kz-ui-sdk";
import { DetailedHTMLProps, ImgHTMLAttributes, VideoHTMLAttributes, useState } from "react";

export interface MediaWithFallbackProps
  extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  wrapperClassName?: string;
}

type FallbackTextProps = {
  text: string;
};

const FallBackText = ({ text }: FallbackTextProps) => (
  <div className={cn("flex h-full w-full items-center justify-center p-1 text-center")}>
    <span className="line-clamp-3 overflow-hidden text-xs">{text}</span>
  </div>
);

const MediaWithFallback = ({ src, alt, className, wrapperClassName, ...props }: MediaWithFallbackProps) => {
  const [isError, setIsError] = useState(false);

  const handleError = () => {
    setIsError(true);
  };

  if (!src || isError) {
    return <FallBackText text={alt || "game icon"} />;
  }

  // If the source is a webm file, render a video element
  if (isVideoFile(src)) {
    const videoProps: DetailedHTMLProps<VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement> = {
      src,
      onError: handleError,
      autoPlay: true,
      muted: true,
      loop: true,
      playsInline: true,
      className: cn("absolute left-0 top-0 h-full w-full object-fill", className),
    };

    return (
      <div className={cn("relative h-full w-full p-1", wrapperClassName)}>
        <video {...videoProps}>
          <FallBackText text={alt || "game icon"} />
        </video>
      </div>
    );
  }

  // Image case: use the img element
  const imgProps = {
    ...props,
  };

  return (
    <div className={cn("relative h-full w-full p-1", wrapperClassName)}>
      <img
        src={src}
        alt={alt}
        onError={handleError}
        className={cn("absolute left-0 top-0 h-full w-full object-fill", className)}
        {...imgProps}
      />
    </div>
  );
};

export default MediaWithFallback;
